export default __webpack_public_path__ + "static/GREEN_GLOW_BG-22c9bf7ef3e205dc13f49c54215071fd.png";